enum GraphicType {
  Circle = 'CIRCLE',
  EmptySet = 'EMPTYSET',
  Star = 'STAR',
  Wheelchair = 'WHEELCHAIR',
  Square = 'SQUARE',
}

export default GraphicType;
